<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Methodology</p>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close"/>
    </header>
    <div class="modal-card-body">
      <div class="block">
        <p class="title is-5">Value Set Alignment</p>
        <p>Each Value Set alignment number is a coverage-weighted average percentile of the underlying metrics in that value set, normalized to a range from 1-10 (1 is the least alignment for a value set, and 10 is the most). Alignment numbers displayed in the table are relative to investment style peers. For example, the "Planet Protector" and "Environmental Violations" alignments for an Industrials ETF are based on percentile ranks relative to other Industrials sector funds.</p>
      </div>
       <div class="block">
        <p class="title is-5">Overall Alignment</p>
        <p>The overall alignment number is a coverage-weighted normalization of the average value of the underlying metric percentiles. For example, Fund A is a 100% equity fund, and fund B has a mix of asset classes, with only a 10% exposure to corporates.
          If both funds have the same score of 9/10 for toxic air pollution, Fund A will have a better overall alignment because the number applies to the whole portfolio, whereas there are holdings in fund B that the metric does not cover.
        <br>
          Because the overall alignment is calculated based on the underlying metrics, value sets that contain more metrics will have a higher contribution towards the overall alignment.</p>
      </div>
      <div class="block">
        <p class="title is-5">Engagement Level</p>
        <p>The Engagement Level is based on a mutual fund manager's engagement activities, including shareholder resolutions, proxy voting, and the amount, intensity, and effectiveness of shareholder engagement. Funds with a shareholder engagmenet level at least as strong as the option selected are displayed in the results table (min/base/deep). For example, funds with "Base" and "Deep" shareholder engagmenet levels will be visible when "Base" shareholder engagement is selected. You can read a more detailed description of the methodology used to determine the shareholder engagement level <a href="https://help.yourstake.org/migration/knowledge/shareholder-engagement-classification-min/base/deep">here.</a></p>
      </div>
      <div class="block">
        <p class="title is-5">ESG Mandate</p>
        <p>ESG mandates are an indication of the intentionality of a fund's values alignment. They are specific commitments to particular investing practices described in a fund's prospectus. YourStake labels funds as having an ESG mandate if the following keywords are found in the Principal Investment Strategies of the fund's prospectus: 'esg','low carbon','climate change','environmental','sustainability assessment','social themes','gender equality','racial equality','racial equity','gender equity','gender diversity','racial diversity','negative impact','postive impact','animal testing','contentious industries'. YourStake's ESG mandate label is not an endorsement or recommendation, and should not be construed as such. As the level of rigor, and specifics of implementation of these mandates vary from fund to fund, YourStake recommends using the ESG mandate label alongside other information, such as shareholder engagement level and holdings analyses when evaluating a fund.</p>
      </div>
      <div class="block">
        <p class="title is-5">Financial Data</p>
        <p>Return and Risk data (Return, Alpha, Beta, Sharpe, Standard Deviation, R-Squared) is from © {{new Date().getFullYear()}} <a target="_blank" rel="noreferrer noopener" href="https://www.morningstar.com/">Morningstar</a>. All Rights Reserved. The information contained herein: (1) is proprietary to Morningstar and/or its content providers; (2) may not be copied or distributed; and (3) is not warranted to be accurate, complete or timely. Neither Morningstar nor its content providers are responsible for any damages or losses arising from any use of this information. Past performance is no guarantee of future results.
        </p>
      </div>
      <hr/>
      <div class="block is-size-7">
        <p>
          Stake PBC is not an investment advisor, and does not provide investment advice or investment recommendations.
          The information contained herein is believed to be from reliable sources, but we make no warranty or guarantee as to the accuracy of the information.
        </p>
      </div>
    </div>
    <div class="modal-card-foot"></div>
  </div>
</template>

<script>
  import Advisor from '@frontend/dash3/js/shared/Advisor.js';
  export default {
    data() {
      return {
      }
    },
    components: {},
    props: {
    },
    methods: {
    },
    computed: {},
    created: function() {
      this.$root.advisor = new Advisor();
    }
  }
</script>

<style lang="scss">
</style>
